export const NIPUN_NAV_ITEMS = [
  { id: "executive", label: "Executive View" },
  { id: "state", label: "State Performance" },
  { id: "district", label: "District Deep Dive" },
  { id: "block", label: "Block & Cluster" },
  { id: "super", label: "Super Schools" },
  { id: "risk", label: "Risk & Intervention" },
  { id: "school", label: "School Drilldown" },
  { id: "governance", label: "Governance" },
];

export const NIPUN_TAB_ITEMS = NIPUN_NAV_ITEMS;
